import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFavorites } from '../hooks/useFavorites';
import { getFileUrl } from '../lib/pb';

export default function FavoritesDrawer() {
  const nav = useNavigate();
  const { items, open, setOpen, remove, clearAll, count } = useFavorites({ registerOpener: true });
  const [confirmClear, setConfirmClear] = useState(false);
  return (
    <div role="dialog" aria-modal="true" className={`fav-drawer ${open ? 'open' : ''}`} onClick={() => setOpen(false)}>
      <div className="fav-backdrop" />
      <div className="fav-panel" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', borderBottom: '1px solid #e5e7eb' }}>
          <div style={{ fontWeight: 600 }}>Mes favoris {count > 0 && <span style={{ color: '#64748b', fontWeight: 400 }}>({count})</span>}</div>
          <div style={{ display: 'flex', gap: 8 }}>
            {count > 0 && (
              <button className="btn ghost" onClick={() => setConfirmClear(true)}>Vider</button>
            )}
            <button className="btn ghost" onClick={() => setOpen(false)}>Fermer</button>
          </div>
        </div>
        <div style={{ padding: 12, overflow: 'auto', flex: 1 }}>
          {items.length === 0 && (
            <p style={{ color: '#64748b' }}>Aucun favori pour le moment.</p>
          )}
          <div style={{ display: 'grid', gap: 10 }}>
            {items.map(p => (
              <div
                key={p.id}
                onClick={() => { setOpen(false); nav(`/produits/${p.slug}`); }}
                style={{ display: 'grid', gridTemplateColumns: '64px 1fr auto', alignItems: 'center', gap: 10, border: '1px solid #e5e7eb', borderRadius: 10, padding: 8, cursor: 'pointer' }}
              >
                <div style={{ width: 64, height: 64, borderRadius: 8, overflow: 'hidden', background: '#f1f5f9' }}>
                  {Array.isArray(p.images) && p.images[0] ? (
                    <img
                      src={getFileUrl(p, p.images[0])}
                      alt={p.title}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'grid', placeItems: 'center', color: '#94a3b8', fontSize: 12 }}>—</div>
                  )}
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.title}</div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button
                    type="button"
                    aria-label="Voir le produit"
                    title="Voir"
                    onClick={(e) => { e.stopPropagation(); setOpen(false); nav(`/produits/${p.slug}`); }}
                    style={{
                      width: 32, height: 32, borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', display: 'grid', placeItems: 'center'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0f172a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    aria-label="Retirer des favoris"
                    title="Retirer"
                    onClick={(e) => { e.stopPropagation(); remove(p.id); }}
                    style={{
                      width: 32, height: 32, borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', display: 'grid', placeItems: 'center'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {confirmClear && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
          }}
          onClick={() => setConfirmClear(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: 'min(92vw, 420px)', borderRadius: 12, background: '#fff',
              boxShadow: '0 20px 60px rgba(2,6,23,0.25)', border: '1px solid #e2e8f0',
              padding: 20
            }}
          >
            <h3 style={{ margin: '0 0 8px 0', fontSize: 18 }}>Vider les favoris ?</h3>
            <p style={{ margin: '0 0 16px 0', color: '#475569', fontSize: 14 }}>
              Cette action retirera tous les produits de vos favoris.
            </p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button type="button" className="btn ghost" onClick={() => setConfirmClear(false)}>Annuler</button>
              <button
                type="button"
                className="btn filled"
                onClick={() => { setConfirmClear(false); clearAll(); }}
              >
                Vider
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
